/* ==========================================================================
   Nutrubabe — mobile sticky add-to-cart

   Does NOT own the cart logic. It mirrors the real product form that Dawn's
   `main-product` section already renders, so variant selection, inventory
   rules, selling plans and cart drawer behaviour all keep working untouched.

   Behaviour:
     · hidden until the real add-to-cart button scrolls out of view
     · price + button label mirrored from the real form, live
     · submitting the bar submits the real form
     · desktop is hidden in CSS, so the observer is skipped there entirely
   ========================================================================== */

(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';

  function init(root) {
    if (!root || root.dataset.nbInit === '1') return;

    // Desktop never shows the bar — don't pay for observers we can't use.
    if (window.matchMedia && !window.matchMedia(MOBILE).matches) return;

    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var realBtn = form.querySelector('[name="add"]');
    if (!realBtn) return;

    root.dataset.nbInit = '1';

    var barBtn = root.querySelector('[data-nb-sticky-submit]');
    var barPrice = root.querySelector('[data-nb-sticky-price]');
    var priceSource = document.querySelector('[data-nb-price-source]')
      || document.querySelector('.price__container .price-item--regular')
      || document.querySelector('.price-item--regular');

    // --- keep the bar's state honest -------------------------------------
    function sync() {
      var disabled = realBtn.disabled || realBtn.getAttribute('aria-disabled') === 'true';
      if (barBtn) {
        barBtn.disabled = disabled;
        barBtn.setAttribute('aria-disabled', String(disabled));
        var realText = (realBtn.textContent || '').trim();
        if (realText) barBtn.textContent = realText;
      }
      if (barPrice && priceSource) {
        var p = (priceSource.textContent || '').trim();
        if (p) barPrice.textContent = p;
      }
    }

    sync();

    // Dawn re-renders the button and price node on variant change, so watch
    // the subtree rather than the node itself.
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(sync);
      mo.observe(form, { subtree: true, childList: true, attributes: true });
      if (priceSource && priceSource.parentNode) {
        mo.observe(priceSource.parentNode, { subtree: true, childList: true, characterData: true });
      }
    }

    // --- reveal once the real button is off screen -----------------------
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            root.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { rootMargin: '0px 0px -40px 0px', threshold: 0 }
      );
      io.observe(realBtn);
    } else {
      root.classList.add('is-visible');
    }

    // --- submit the real form -------------------------------------------
    if (barBtn) {
      barBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (barBtn.disabled) return;
        if (typeof form.requestSubmit === 'function') {
          // requestSubmit fires validation + submit handlers; .submit() skips both,
          // which would bypass Dawn's cart-drawer interception.
          form.requestSubmit(realBtn);
        } else {
          realBtn.click();
        }
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-nb-sticky-atc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when the theme editor swaps the section back in.
  document.addEventListener('shopify:section:load', boot);
})();
